module.exports = __webpack_public_path__ + "Lato-LightItalic.a361e58e00741b26002d.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-LightItalic.woff
// module id = ../../../../../src/assets/fonts/Lato-LightItalic.woff
// module chunks = styles